import { Fragment } from 'react'
import { Check, Info, X } from 'react-feather'
import { toast } from 'react-toastify'
import Avatar from '@components/avatar'


const ToastComponent = ({ title, icon, color }) => (
  <Fragment>
    <div className='toastify-header pb-0'>
      <div className='title-wrapper'>
        {icon && <Avatar size='sm' color={color} icon={icon} />}
        <h6 className='toast-title'>{title}</h6>
      </div>
    </div>
  </Fragment>
)


export const sucessToast = (msg) => {
  toast.success(<ToastComponent title={msg} color='success' icon={<Check />} />, {
    icon: false,
    autoClose: 4100,
    hideProgressBar: true,
    closeButton: false
  })
}

export const infoToast = (msg) => {
  toast.info(<ToastComponent title={msg} color='info' icon={<Info />} />, {
    icon: false,
    autoClose: 4100,
    hideProgressBar: true,
    closeButton: false
  })
}

export const errorToast = (msg) => {
  toast.error(<ToastComponent title={`Error. ${msg}`} color='danger' icon={<X />} />, {
    icon: false,
    autoClose: 4100,
    hideProgressBar: true,
    closeButton: false
  })
}

export const sucessToastTime = (msg, time) => {
  toast.success(<ToastComponent title={msg} color='success' icon={<Check />} />, {
    icon: false,
    autoClose: time,
    hideProgressBar: true,
    closeButton: false
  })
}

export const errorToastTime = (msg, time) => {
  toast.error(<ToastComponent title={`Error. ${msg}`} color='danger' icon={<X />} />, {
    icon: false,
    autoClose: time,
    hideProgressBar: true,
    closeButton: false
  })
}

export const warningToast = (msg) => {
  toast.warning(<ToastComponent title={`!. ${msg}`} color='warning' icon={<X />} />, {
    icon: false,
    autoClose: 4100,
    hideProgressBar: true,
    closeButton: false
  })
}

export const warningToastTime = (msg, time) => {
  toast.error(<ToastComponent title={`! ${msg}`} color='warning' icon={<X />} />, {
    icon: false,
    autoClose: time,
    hideProgressBar: true,
    closeButton: false
  })
}